// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...sanitizeProps(props)}>
    <path d="M22 22.21h-5.96L10.6 14.3l-6.81 7.9H2l7.83-9.02L2 1.8h5.96l5.1 7.49 6.47-7.5h1.79l-7.4 8.69L22 22.2Zm-10.55-8.93 5.36 7.66h2.72l-6.55-9.45-.77-1.1-5.1-7.24H4.38l6.3 9.02.77 1.1Z" />
  </BaseIcon>
)
